/** @format */

import React, { Component } from 'react';
import { Table, Icon, Loader, Dimmer } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import { getDateFromTimestamp } from '../../helpers/getDateFromTimestamp';
import renderProgressIcon from '../../helpers/renderProgressIcon';
import DeepSearch from './DeepSearch/DeepSearch';
import SalesToolbar from './SalesToolbar/SalesToolbar';
import './Sales.css';

@inject('SalesStore')
@observer
class Sales extends Component {
  renderTableHeader = () => {
    let { SalesStore } = this.props;
    let renderTableHeader = null;
    let tableKeys = [
      'CLIENTE',
      'PRIMO PRODOTTO',
      'STATO',
      'OGG. VENDUTI',
      'TOT.',
      'DATA E ORA',
    ];
    renderTableHeader = tableKeys.map(key => {
      return (
        <Table.HeaderCell
          className="table-head-cell"
          onClick={() => SalesStore.sortSalesBy(key)}
          key={key}
        >
          {key}
        </Table.HeaderCell>
      );
    });
    return <Table.Row key="">{renderTableHeader}</Table.Row>;
  };

  renderTableBody = () => {
    let renderTableBody = null;
    const { SalesStore } = this.props;
    const advancedSearch = SalesStore.salesParams.advancedSearch.active;
    if (SalesStore.sales !== undefined && SalesStore.sales !== null) {
      let salesValues = Object.values(SalesStore.sales);
      let searchValue = SalesStore.salesParams.searchValue;
      let searchMinPrice = SalesStore.salesParams.advancedSearch.priceRange.min;
      let searchMaxPrice = SalesStore.salesParams.advancedSearch.priceRange.max;

      SalesStore.assignKey();

      let sortedsalesValues = _.orderBy(
        salesValues,
        ['data.' + SalesStore.salesParams.orderBy.prop],
        [SalesStore.salesParams.orderBy.direction],
      );

      if (searchValue !== '') {
        sortedsalesValues.forEach((sale, index) => {
          if (
            sale.data.clientName
              .toLowerCase()
              .indexOf(searchValue.toLowerCase()) < 0
          ) {
            delete sortedsalesValues[index];
          }
        });
      }

      if (advancedSearch) {
        sortedsalesValues = sortedsalesValues.filter(value => {
          return (
            value.data.tot >= searchMinPrice && value.data.tot <= searchMaxPrice
          );
        });
      }

      if (salesValues.length !== 0) {
        renderTableBody = sortedsalesValues.map((value, index) => {
          const key = value.data.key;
          return (
            <Table.Row
              key={key}
              onClick={() => this.props.history.push('/sales/' + key + '/view')}
            >
              <Table.Cell>
                {value.data.clientName
                  .toLowerCase()
                  .split(' ')
                  .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                  .join(' ')}
              </Table.Cell>
              <Table.Cell>{value.data.items[0].data.name}</Table.Cell>
              <Table.Cell>{value.data.status}</Table.Cell>
              <Table.Cell>{Object.values(value.data.items).length}</Table.Cell>
              <Table.Cell>{value.data.tot}€</Table.Cell>
              <Table.Cell>
                {getDateFromTimestamp(value.data.timestamp)}
              </Table.Cell>
            </Table.Row>
          );
        });
      } else {
        renderTableBody = (
          <Table.Row>
            <Table.Cell
              colSpan="6"
              className="table-preloader"
              textAlign="center"
            >
              <Dimmer inverted active>
                <Loader size="small" inverted />
              </Dimmer>
            </Table.Cell>
          </Table.Row>
        );
      }
    }

    return renderTableBody;
  };

  renderIcon = progress => {
    const icon = renderProgressIcon(progress);
    return <Icon name={icon.name} loading={icon.loading} color={icon.color} />;
  };

  renderStatusIcon = status => {
    let icon = null;
    switch (true) {
      case status === 'attiva':
        icon = <Icon name="circle thin" size="mini" color="green" />;
        break;
      default:
    }
    return icon;
  };

  render() {
    const { SalesStore } = this.props;
    return (
      <div>
        <SalesToolbar />
        <DeepSearch />
        <Table sortable size="small" selectable className="app-manage-table">
          <Table.Header className="table-head">
            {this.renderTableHeader()}
          </Table.Header>
          <Table.Body>
            {this.renderTableBody()}
            <Table.Row
              className="clickable"
              onClick={() => SalesStore.loadMoreSales()}
            >
              <Table.Cell colSpan={6} textAlign="center">
                <Icon name="download" />
                <strong>Carica più vendite</strong>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default withRouter(Sales);
